import React, { useEffect, useState, useContext, useRef } from 'react';

import { ContenedorParametros } from '../../components/utils/ContenedorParametros';
import { Tooltip } from '../../components/utils/Tooltip';
import { DatePickerABX } from '../../components/pickers/DatePicker';
import { useActividades } from '../../../hooks/actividades/useActividades';
import { formatDate, obtenerHoraActual, primeraLetraMayuscula, primeraLetraMayusculaOracion } from '../../../utils/utils';
import { NuevoSelectAutocomplete } from '../../components/forms/NuevoSelectAutocomplete';
import { useUsuarios } from '../../../hooks/usuarios/useUsuarios';
import { Modal } from '../../components/modal/Modal';
import { UserContext } from '../../../context/provider/UserProvider';
import { useModal } from '../../../hooks/useModal';
import { LineaCarga } from '../../components/LineaCarga';
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { PaginacionABEXA } from '../../components/PaginacionABEXA';
import { MultiSelectorFecha } from '../../components/pickers/MultiSelectorFecha';
import { useProyectos } from '../../../hooks/proyectos/useProyectos';

export const ActividadesPersonal = () => {
    const { stateUser } = useContext(UserContext);
    const [ startDate, setStartDate ] = useState(() => {
        // const currentDate = new Date();
        // currentDate.setDate(currentDate.getDate() - 400);
        return formatDate(new Date(2023, 0, 1));
    });
    const [ endDate, setEndDate ] = useState(formatDate(new Date()));
    
    const classNameInput = "containerScroll caret-white p-2 text-white h-[30px] rounded  w-full bg-zinc-900 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
    const idTablaRepuestos = "tabla-repuestos";

    const [ usuarioSeleccionado, setUsuarioSeleccionado] = useState(0);
    const [ descripcionTicket, setDescripcionTicket ] = useState({ticket: 0, nombreTicket: '', alcance: '', objetivo: ''});
    const [ isOpenDescripcionTicket, openModalDescripcionTicket, closeModalDescripcionTicket ] = useModal(false);
    const [ estadoSeleccionado, setEstadoSeleccionado ] = useState(0);
    const [ isOpenPausarActividad, openModalPausarActividad, closeModalPausarActividad ] = useModal(false);
    const [ dataConFiltros, setDataConFiltros ] = useState([])
    const [ actividadesAgrupadas, setActividadesAgrupadas ] = useState([])
    const [ proyectoSeleccionado, setProyectoSeleccionado ] = useState(0)
    const tablaActividadesRef = useRef(null)
    const estadosActividad = [
        { codEstado: 9,nomEstado : "Pendiente", abrevEstado: "PEN"},
        { codEstado: 48,nomEstado : "En Proceso", abrevEstado: "ATE"},
        { codEstado: 51,nomEstado : "Finalizado", abrevEstado: "FIN"},
        { codEstado: 56,nomEstado : "Pausado", abrevEstado: "PAU"},
    ]
    const {
        listarActividadesPorUsuario,
        actividadesUsuario,
        obtenerActividadDetalle,
        isOpenModalValidarEstado,
        closeModalValidarEstado,
        cambiarEstadoActividad,
        openModalActividad,
        isOpenModalActividad,
        closeModalActividad,
        guardarEditarActividad,
        editarValorActividad,
        actividad,
        obtenerCambiarEstadoActividad,
        tipoPausa,
        listarTipoPausa,
        pausarActividadConMotivo,
        finalizarActividadPausada,
        editarValorActividadPausa,
        openModalValidarEstado,
        editarValorInicioFinActividad,
        inicioFinActividad,
        loading,
        setLoading
    } = useActividades();

    const {
        listarTicketProyectos,
        listaProyectos
    } = useProyectos()

    const {
        listarUsuarios,
        usuarios,
    } = useUsuarios();

    useEffect(() => {
        document.title = "XProject | Actividades del personal";
        (async ()=> {
            await listarUsuarios(stateUser.codAreaActual);
            await listarTipoPausa();

        })()
    },[]);

    useEffect(() => {
        setLoading(true);
        listarTicketProyectos(startDate,endDate,usuarioSeleccionado === 0 ? stateUser.codUsuario : usuarioSeleccionado);
        usuarios.length > 0 && startDate && endDate && listarActividadesPorUsuario(
            startDate,
            endDate,
            usuarioSeleccionado === 0 ? stateUser.codUsuario : usuarioSeleccionado)
    },[startDate,endDate,usuarios]);


    const usuariosConvertidos = usuarios.map(option => ({
        value: option.codUsuario,
        label: option.nomUsuario
    }));
    const proyectosConvertidos = listaProyectos.map(option => ({
        value: option.codTicket,
        label: `[ ${ option.codTicket} ] ` + option.nomTicket
    }));

    useEffect(() => {
        !loading && setLoading(true)
        setActividadesAgrupadas(
            actividadesUsuario
            .filter(e => e.codTicket === proyectoSeleccionado || proyectoSeleccionado === 0)
            .filter(e => e.codEstadoTicketActividad === estadoSeleccionado || estadoSeleccionado === 0)
            .reduce((acumulador, actividad) => {
                const { codTicket,
                    codTicketEntregable,
                    nomEntregable,
                    nomTicket,
                    objetivo,
                    alcance,
                    ...actividadRestante
                } = actividad;
                const indiceTicket = acumulador.findIndex(item => item.codTicket === codTicket);
        
                if (indiceTicket === -1) {
                  // Si no existe el ticket, se crea un nuevo objeto
                  acumulador.push({
                    codTicket,
                    nomTicket,
                    objetivo,
                    alcance,
                    cantidadFilas: 1,
                    entregable: [{
                      codTicketEntregable,
                      nomEntregable,
                      Actividades: [actividadRestante]
                    }]
                  });
                }
                else {
                    const indiceEntregable = acumulador[indiceTicket].entregable.findIndex(item => item.codTicketEntregable === codTicketEntregable);
                    if (indiceEntregable === -1) {
                        // Si no existe el entregable, se agrega uno nuevo
                        acumulador[indiceTicket].entregable.push({
                            codTicketEntregable,
                            nomEntregable,
                            Actividades: [actividadRestante]
                        });
                    }
                    else {
                        // Si ya existe el entregable, se añade la actividad al arreglo existente
                        acumulador[indiceTicket].entregable[indiceEntregable].Actividades.push(actividad);
                    }
                    acumulador[indiceTicket].cantidadFilas += 1;
                }
                return acumulador;
            }, [])
        )
    },[actividadesUsuario,estadoSeleccionado, proyectoSeleccionado])

    useEffect(() => {
        if(tablaActividadesRef.current){
            setLoading(false)
        }
    },[dataConFiltros])

    const guardarActividadPausada =async () => {
        const isValid  = await pausarActividadConMotivo()
        if(isValid){
            await listarActividadesPorUsuario(
                startDate,
                endDate,
                usuarioSeleccionado === 0 ? stateUser.codUsuario : usuarioSeleccionado
            )
            closeModalPausarActividad()
        }
    }

    const guardarFinActividadPausada = async (codTicketActividad) => {
        const isValid = await finalizarActividadPausada(codTicketActividad);
        if(isValid){
            await listarActividadesPorUsuario(
                startDate,
                endDate,
                usuarioSeleccionado === 0 ? stateUser.codUsuario : usuarioSeleccionado
            )
        }
    }

    const registrarActividad = async () => {
        const isValid = await guardarEditarActividad();
        if(isValid){
            closeModalActividad();
            listarActividadesPorUsuario(
                startDate,
                endDate,
                usuarioSeleccionado === 0 ? stateUser.codUsuario : usuarioSeleccionado
            );
        }
    }

    const registrarInicioFinActividad = async () => {
        const isValid = await cambiarEstadoActividad();
        if(isValid){
            await listarActividadesPorUsuario(
                startDate,
                endDate,
                usuarioSeleccionado === 0 ? stateUser.codUsuario : usuarioSeleccionado
            );
            closeModalValidarEstado()
        }
    }

    const setValoresInicioFinActividad = (proyecto, actividad) => {
        editarValorInicioFinActividad('codTicket',proyecto.codTicket);
        editarValorInicioFinActividad('codTicketActividad',actividad.codTicketActividad);
        editarValorInicioFinActividad('codEstadoTicketActividad',actividad.codEstadoTicketActividad);
        editarValorInicioFinActividad('nomActividad',actividad.nomActividad);
        editarValorInicioFinActividad('fecha',formatDate(new Date()));
        editarValorInicioFinActividad('hora',obtenerHoraActual());
    }

    const abrirModalActividad = async (data, entregable) => {
        await obtenerActividadDetalle();
        editarValorActividad('codTicket',data.codTicket)
        editarValorActividad('codTicketEntregable',entregable.codTicketEntregable);
        editarValorActividad("codUsuarioResponsable",stateUser.codUsuario);
        editarValorActividad('fechaInicioProgramadoActividad', formatDate(new Date()))
        editarValorActividad('horaInicioProgramadoActividad', obtenerHoraActual())
        editarValorActividad('fechaFinProgramadoActividad', formatDate(new Date()))
        editarValorActividad('horaFinProgramadoActividad', obtenerHoraActual())
        openModalActividad()
    }

    const obtenerEstado = (codEstado,nomEstado) => {
        let color =''
        switch(codEstado){
            case 9: //Pendiente
                color = 'bg-yellow-500';
                break;
            case 48: //En proceso
                color = 'bg-green-500';
                break;
            case 51: //Finalizado
                color = 'bg-red-500';
                break;
            default:
                color = 'bg-cyan-500';
                break;
        }
        return <p className={`${color} w-[70px] rounded px-2 text-xs whitespace-nowrap`}>{primeraLetraMayuscula(nomEstado)}</p>
    }

    return (
        <>
            {loading && <LineaCarga/>}
            <ContenedorParametros titulo='Actividades del personal' tablaId={idTablaRepuestos}>
                <MultiSelectorFecha
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
                <i className='fas fa-sliders-h cursor-pointer' data-for={'estado'} data-tip={'estado'}></i>
                <div className='w-[150px] text-xs'>
                    <select
                        className={`${classNameInput} containerScroll h-[30px]`}
                        onChange={(e)=> setEstadoSeleccionado(Number(e.target.value))}
                    >
                        <option value={0}>-- Todos --</option>
                        {
                            estadosActividad.map(e => {
                                return <option value={e.codEstado}>{e.nomEstado}</option>
                            })
                        }
                    </select>
                </div>
                <i className='fa fa-filter' title='Proyectos'></i>
                <div className='w-[250px]'>
                    <NuevoSelectAutocomplete
                        options={proyectosConvertidos}
                        textoInput={(valor) => setProyectoSeleccionado(valor)}
                        valorInput={(valor) => console.log()}
                        valorPorDefecto={0}
                        opcionTodos={true}
                    />
                </div>
                <Tooltip id={'estado'}>Estado</Tooltip>
                {
                    (stateUser.codUsuario === 113 || stateUser.codUsuario === 61 || stateUser.codUsuario === 95 || stateUser.codUsuario === 130) &&
                     <>
                    <div className='flex w-[350px] items-center gap-2'>
                        <i className='fa fa-user'></i>
                        {
                            usuarios.length > 0 &&
                            <NuevoSelectAutocomplete
                                options={usuariosConvertidos}
                                textoInput={(valor) => setUsuarioSeleccionado(valor)}
                                valorInput={(valor) => listarActividadesPorUsuario(startDate,endDate,valor)}
                                valorPorDefecto={stateUser.codUsuario}
                                opcionTodos={true}
                            ></NuevoSelectAutocomplete>
                        }
                    </div>
                     </>
                }
                <BotonProcesar onClick={()=>{
                    listarActividadesPorUsuario(
                        startDate,
                        endDate,
                        usuarioSeleccionado === 0 ? stateUser.codUsuario : usuarioSeleccionado
                    )
                }}></BotonProcesar>

            </ContenedorParametros>
            <div className=" containerScroll max-h-[85%] mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla" >
                <table id={idTablaRepuestos} className=" tableResponsive " ref={tablaActividadesRef}>
                    <thead>
                        <tr key={'cabecera'}>
                            <th className="w-[3%]">N°</th>
                            <th className="w-[7%]">COD.TICKET</th>
                            <th className="w-[20%] text-left">NOMBRE DEL ENTREGABLE</th>
                            <th className="w-[23%]">ACTIVIDAD</th>
                            <th className="w-[5%]">F. INICIO PROG.</th>
                            <th className="w-[5%]">F. FIN PROG.</th>
                            <th className="w-[6%]">F. INICIO EJEC.</th>
                            <th className="w-[6%]">F. FIN EJEC.</th>
                            <th className="w-[5%]">ESTADO</th>
                            <th className="w-[5%]"></th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        dataConFiltros.length > 0 ?
                            dataConFiltros.map((data,i) => (
                                data.entregable.map((entregable,j) => (
                                    entregable.Actividades.map((actividad,k) => (
                                        <tr
                                            key={i + 1 + '_' + j + 1 + '-' + k + 1}
                                            style={{background: i % 2 === 0 ? '#121212be' : '#414040a1' }}
                                        >
                                            {
                                                k === 0 && j === 0  &&(
                                                    <>
                                                        <td
                                                            rowSpan={data.cantidadFilas}
                                                            className='w-[3%] text-center'
                                                        >{i+1}</td>
                                                        <td
                                                            rowSpan={data.cantidadFilas}
                                                            className='text-center w-[5%]'
                                                            onClick={() => {
                                                                setDescripcionTicket({
                                                                    ticket: data.codTicket,
                                                                    nombreTicket: data.nomTicket,
                                                                    objetivo: data.objetivo,
                                                                    alcance: data.alcance,
                                                                })
                                                                openModalDescripcionTicket()
                                                            }}
                                                        >
                                                            <p
                                                                className='bg-blue-600 px-2 rounded w-[50px] max-[60px]'
                                                                data-for={i+data.nomTicket}
                                                                data-tip={i+data.nomTicket}
                                                            >{data.codTicket}</p>
                                                            <Tooltip id={i+data.nomTicket}>{data.nomTicket}</Tooltip>
                                                        </td>
                                                    </>
                                                )
                                            }
                                            {
                                                k === 0 && (
                                                    <td
                                                        rowSpan={ entregable.Actividades.length}
                                                        className='w-[20%]  max-w-[200px]'
                                                    >
                                                        <div className='flex gap-2' key={k +1 }>
                                                            <p className='w-[90%] break-words overflow-hidden text-ellipsis whitespace-nowrap'>{entregable.nomEntregable}</p>
                                                            {
                                                                stateUser.codUsuario === actividad.codUsuarioResponsableActividad ?
                                                                <>
                                                                    <p
                                                                        data-tip={'regActividad'}
                                                                        data-for={'regActividad'}
                                                                        className='fa fa-plus-circle text-lg text-blue-500 text-right w-[5%]'
                                                                        onClick={() => abrirModalActividad(data,entregable)}
                                                                    ></p>
                                                                    <Tooltip id={'regActividad'}>Registrar actividad</Tooltip>
                                                                </>
                                                                : ''
                                                            }
                                                        </div>
                                                    </td>
                                                )
                                            }
                                            <td
                                                className='w-[25%] max-w-[400px]'
                                                onClick={async () => {
                                                    if(actividad.codUsuarioResponsableActividad === stateUser.codUsuario){
                                                        await obtenerActividadDetalle(actividad.codTicketActividad);
                                                        editarValorActividad('codTicket',data.codTicket);
                                                        openModalActividad();
                                                    }
                                                }}
                                            >
                                                <p
                                                    className='w-[95%] whitespace-nowrap text-ellipsis overflow-hidden underline hover:text-blue-500 '
                                                >{primeraLetraMayusculaOracion(actividad.nomActividad)}</p>
                                            </td>
                                            <td className=" whitespace-nowrap w-[5%]">
                                                {actividad.fechaInicioProgramado}
                                            </td>
                                            <td className=" whitespace-nowrap w-[5%]">
                                                {actividad.fechaFinProgramado}
                                            </td>
                                            <td className=" whitespace-nowrap w-[6%]">
                                                {actividad.fechaInicioReal}
                                            </td>
                                            <td className=" whitespace-nowrap w-[6%]">
                                                {actividad.fechaFinReal}
                                            </td>
                                            <td className='text-center w-[5%]'>
                                                {obtenerEstado(actividad.codEstadoTicketActividad, actividad.nomEstadoActividad)}
                                            </td>
                                            <td className='w-[5%]'>
                                                <div className=''>
                                                    {
                                                        ((actividad.codEstadoTicketActividad === 9 || actividad.codEstadoTicketActividad === 56) && 
                                                            actividad.codUsuarioResponsableActividad === stateUser.codUsuario
                                                        ) &&
                                                        <>
                                                            <i
                                                                className='fa fa-play text-xs p-1 bg-green-500 rounded cursor-pointer'
                                                                onClick={() => {
                                                                    setValoresInicioFinActividad(data, actividad);
                                                                    actividad.codEstadoTicketActividad === 9 ? openModalValidarEstado() : guardarFinActividadPausada(actividad.codTicketActividad)
                                                                }}
                                                                data-tip={'inicioActividad'}
                                                                data-for={'inicioActividad'}
                                                            ></i>
                                                            <Tooltip id="inicioActividad">Iniciar actividad</Tooltip>
                                                        </>
                                                    }
                                                    {
                                                    (actividad.codEstadoTicketActividad === 48 && 
                                                        actividad.codUsuarioResponsableActividad === stateUser.codUsuario
                                                    ) ?
                                                        <>
                                                            <div className='flex gap-2'>
                                                                <i
                                                                    className='fa fa-pause text-xs p-1 bg-yellow-500 rounded cursor-pointer'
                                                                    data-tip="pausarActividad"
                                                                    data-for="pausarActividad"
                                                                    onClick={async () => {
                                                                        editarValorInicioFinActividad('codTicketActividad',actividad.codTicketActividad)
                                                                        editarValorInicioFinActividad('nomActividad',actividad.nomActividad)
                                                                        editarValorActividadPausa('codTicketActividad',actividad.codTicketActividad)
                                                                        editarValorActividadPausa('codTicketActividadPausaTipo',tipoPausa[0].codTicketActividadPausaTipo)
                                                                        openModalPausarActividad();
                                                                    }}
                                                                >
                                                                </i>
                                                                <Tooltip id="pausarActividad"></Tooltip>
                                                                <i
                                                                    className='fa fa-stop text-xs p-1 bg-red-500 rounded cursor-pointer'
                                                                    onClick={() => {
                                                                        setValoresInicioFinActividad(data, actividad);
                                                                        obtenerCambiarEstadoActividad()
                                                                        openModalValidarEstado()
                                                                    }}
                                                                    data-tip={'finActividad'}
                                                                    data-for={'finActividad'}
                                                                ></i>
                                                                <Tooltip id="finActividad">Finalizar actividad</Tooltip>
                                                            </div>
                                                        </>
                                                        : ''
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ))
                                
                            ))
                        :
                            <tr><td colSpan="11" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                    }
                    </tbody>
                </table>
            </div>
            <PaginacionABEXA
                data={actividadesAgrupadas}
                setDataReturn={setDataConFiltros}
                numeroFilas={20}
            ></PaginacionABEXA>

            {/* MODAL INICIAR FINALIZAR ACTIVIDAD */}
            <Modal
                isOpen={isOpenModalValidarEstado}
                closeModal={closeModalValidarEstado}
                textButtons={{
                    confirm: 'Si',
                    denied: 'No'
                }}
                title={`[ ${inicioFinActividad.codTicket} ] ${inicioFinActividad.codEstadoTicketActividad === 9 ? 'Iniciar ' : 'Finalizar '} Actividad`}
                action={()=> registrarInicioFinActividad()}
            >
                {
                    isOpenModalValidarEstado && (
                        <div className='h-[200px] flex flex-col gap-2'>
                            <div className='border rounded'>
                                <div className='w-full py-1 '>
                                    <div className='flex w-full gap-2  justify-center text-lg font-bold p-2  rounded'>
                                        <span className='w-[90px]'>Actividad</span>
                                        <span className=''>:</span>
                                        <span className='whitespace-nowrap text-ellipsis overflow-hidden w-[350px]'>{inicioFinActividad.nomActividad}</span>
                                    </div>
                                </div>
                                <div className='w-full py-3'>
                                    <div className='flex w-full gap-2 px-2 text-lg font-bold'>
                                        <span className='w-[90px]'>Fecha</span>
                                        <span>:</span>
                                        <div className='flex gap-2'>
                                            <div className='w-[120px]'>
                                                <DatePickerABX
                                                    date={inicioFinActividad.fecha}
                                                    setDate={editarValorInicioFinActividad}
                                                    classNameInput={'lg:w-[70px] lg:text-xs lg:p-[2px]  bg-zinc-900 border border-zinc-600'}
                                                    keyDate='fecha'
                                                    ocultarIcono={true}
                                                />
                                            </div>
                                            <input 
                                                type='time'
                                                className={`${classNameInput} p-2`}
                                                value={inicioFinActividad.hora}
                                                onChange={(e) => editarValorInicioFinActividad('hora',e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-col items-center gap-2 py-3'>
                                <img
                                    src='https://upload.wikimedia.org/wikipedia/commons/1/11/Blue_question_mark_icon.svg'
                                    className='w-[40px] h-[40px]'
                                    alt=''
                                />
                                <span className='text-lg'>¿Esta seguro de realizar la operación ?</span>
                            </div>

                        </div>
                    )
                }

            </Modal>

            {/* MODAL DETALLE ACTIVIDAD */}
            <Modal
                isOpen={isOpenModalActividad}
                closeModal={closeModalActividad}
                action={() => registrarActividad()}
                title={`[ N°${actividad.codTicket} ] ${actividad.codTicketActividad === 0 ? 'Crear actividad' : 'Editar actividad'}`}
            >
                {
                    isOpenModalActividad &&
                    <div className='p-1 h-[200px] gap-1 flex flex-col w-[450px] lg:w-full lg:h-full'>
                        <div className='flex lg:flex-col gap-2 items-center'>
                            <span className='w-[25%] lg:w-full'>Nombre</span>
                            <div className='w-[75%] flex lg:w-full lg:block'>
                                <textarea
                                    className={`${classNameInput} p-1 h-[80px] text-base`}
                                    onChange={(e)=> editarValorActividad('nomActividad',e.target.value)}
                                    value={actividad.nomActividad}
                                >
                                </textarea>
                            </div>
                        </div>
                        <div className='flex gap-2 items-center lg:flex-col'>
                            <span className='w-[25%] lg:w-full'>Responsable</span>
                            <span className='w-[75%] lg:w-full lg:p-1 lg:bg-zinc-600 lg:rounded'>{usuarios.filter(u => u.codUsuario === stateUser.codUsuario)[0].nomUsuario}</span>
                        </div>
                        <div className='flex gap-2 items-center'>
                            <span className='w-[25%]'>Fecha inicio</span>
                            <div className='w-[75%] flex'>
                                <div className='w-[120px] pr-2'>
                                    <DatePickerABX
                                        date={actividad.fechaInicioProgramadoActividad}
                                        setDate={editarValorActividad}
                                        classNameInput={'lg:w-[70px] lg:text-xs lg:p-[2px] bg-zinc-900 border border-zinc-600'}
                                        keyDate='fechaInicioProgramadoActividad'
                                        ocultarIcono={true}
                                    />
                                </div>
                                <input 
                                    type='time'
                                    className={`${classNameInput} w-[100px] p-1 text-sm`}
                                    value={actividad.horaInicioProgramadoActividad}
                                    onChange={(e) => editarValorActividad('horaInicioProgramadoActividad',e.target.value)}
                                />
                            </div>
                        </div>
                        <div className='flex gap-2 items-center'>
                            <span className='w-[25%]'>Fecha fin</span>
                            <div className='flex w-[75%]'>
                                <div className='w-[120px] pr-2'>
                                    <DatePickerABX
                                        date={actividad.fechaFinProgramadoActividad}
                                        setDate={editarValorActividad}
                                        classNameInput={'lg:w-[70px] lg:text-xs lg:p-[2px]  bg-zinc-900 border border-zinc-600'}
                                        keyDate='fechaFinProgramadoActividad'
                                        ocultarIcono={true}
                                    />
                                </div>
                                <input 
                                    type='time'
                                    className={`${classNameInput} w-[100px] p-1 text-sm`}
                                    value={actividad.horaFinProgramadoActividad}
                                    onChange={(e) => editarValorActividad('horaFinProgramadoActividad',e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                }
            </Modal>

            {/* MODAL PARA MOSTRAR DETALLE DEL TICKET */}
            <Modal
                title={`N° ${descripcionTicket.ticket} - ${descripcionTicket.nombreTicket}`}
                isOpen={isOpenDescripcionTicket}
                closeModal={closeModalDescripcionTicket}
                validButton={{
                    confirm: false,
                    denied: true
                }}
                width={'w-[450px]'}
            >
                <section className='w-[400px] p-2 flex flex-col gap-[5px]' key={'divContenedorDetalle'}>
                    <ul className='list-disc'>
                        <li>
                            <label className='font-bold w-full'>Objetivo:</label>
                            <p className='break-words text-justify'>{descripcionTicket.objetivo}</p>
                        </li>
                        {
                            descripcionTicket.alcance !== '' &&(
                                <li className='w-full'>
                                    <label className=' font-bold'>Alcance:</label>
                                    <p className='break-words text-justify'>{descripcionTicket.alcance}</p>
                                </li>
                            )
                        }
                    </ul>

                </section>
            </Modal>

            {/* MODAL PARA PAUSAR ACTIVIDAD */}
            <Modal
                title={`Pausar: ${inicioFinActividad.nomActividad.slice(0,40)}`}
                isOpen={isOpenPausarActividad}
                closeModal={closeModalPausarActividad}
                action={()=> guardarActividadPausada()}
            >
                {
                    isOpenPausarActividad &&
                    <div className=''>
                        <label>Motivo</label>
                        <select
                            className={`min-h-[40px] ${classNameInput}`}
                            onChange={(e) => editarValorActividadPausa('codTicketActividadPausaTipo',e.target.value)}
                        >
                            {
                                tipoPausa.length > 0 ? 
                                    tipoPausa.map(tipo => (
                                        <option key={tipo.codTicketActividadPausaTipo} value={tipo.codTicketActividadPausaTipo}>{tipo.nomActividadPausaTipo}</option>
                                    ))
                                : ''
                            }
                        </select>
                    </div>
                }
            </Modal>
        </>
    )
}